import { Modal, Button as Btn } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { useTranslation } from "contexts/TranslationContext";
// Reuse the existing phone-verification illustration (matches the design).
// Swap for a dedicated asset when one is provided.
import ivrPending from "assets/svg/ivrPending.svg";

// Shown after an Other Services request is submitted. Defaults to the
// IVR-verification copy used by Restructure/Topup (same pattern as
// FinanceProducts / DentalProductsV2). Servicing requests (Early Settlement,
// Cancelation) trigger no IVR call, so they pass their own copy keys.
const SubmitSuccessModal = ({
  open,
  onContinue,
  titleKey = "OTHER_SERVICES.SUBMIT_SUCCESS_TITLE",
  messageKey = "OTHER_SERVICES.SUBMIT_SUCCESS_MSG",
  image = ivrPending,
}) => {
  const { translate } = useTranslation();

  return (
    <Modal
      open={open}
      footer={null}
      closable
      closeIcon={<CloseOutlined style={{ fontSize: "18px", color: "#000" }} />}
      onCancel={onContinue}
      centered
      width={520}
      bodyStyle={{ padding: "40px" }}
    >
      <div className="flex flex-col items-center text-center">
        <img src={image} alt="" className="w-56 h-56 mb-6 object-contain" />
        <h2 className="text-2xl font-bold mb-3 text-[#1F1F1F]">
          {translate(titleKey)}
        </h2>
        <p className="text-[#8E9196] text-base leading-relaxed mb-6">
          {translate(messageKey)}
        </p>
        <Btn
          className="rounded-full bg-primary text-white font-semibold px-12 py-5 border border-primary hover:!border-primary hover:border-solid hover:!text-primary"
          onClick={onContinue}
        >
          {translate("OTHER_SERVICES.CONTINUE")}
        </Btn>
      </div>
    </Modal>
  );
};

export default SubmitSuccessModal;
